module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-rating-content-violence.52b00685.svg";